import { resolveUrl } from "@/lib/api";

export default function Header({ settings }) {
  return (
    <header className="relative bg-dark border-b border-[#e5b54b]/25 fade-up" data-testid="site-header">
      <div className="px-6 sm:px-10 pt-10 pb-10 flex flex-col items-center text-center gap-4">
        {settings.logo_url && (
          <img
            src={resolveUrl(settings.logo_url)}
            alt="logo"
            className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover ring-2 ring-[#e5b54b]/50"
            data-testid="site-logo"
          />
        )}
        <h1
          className="font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight text-[#ffd700]"
          data-testid="site-title"
        >
          {settings.app_name || "Royal Market"}
        </h1>
        <div className="w-40 border-b border-[#e5b54b]/60 pt-1" aria-hidden="true" />
        <p className="text-sm sm:text-base text-[#d8cfa3] max-w-3xl leading-relaxed" data-testid="welcome-text">
          {settings.welcome_text}
        </p>
      </div>
    </header>
  );
}
